
import { computed } from 'vue'
import { CImportBase, CImportInformation } from '@invivodf/common/src/contexts/parameters'
import { capitalize } from 'lodash'
import { useStore } from '../../composables/useStore'
import { usersRolesService } from '../../services'

const csvFileProperties = {
  name: 'users-roles.csv',
  full_path: '/assets/csv/users-roles.csv',
}

export default {
  name: 'CImportUsersRoles',
  components: {
    CImportBase,
    CImportInformation,
  },
  setup() {
    const store = useStore()

    const usersRolesImportInformation = computed(() => {
      return store.getters.usersRolesImportInformation
    })
    const distributorId = computed(() => {
      return store.getters.cooperativeId
    })
    const partner = computed(() => {
      return store.getters.cooperative
    })

    const importInformation = computed(() => {
      return {
        count: usersRolesImportInformation.value?.userRolesCount,
        lastImportAt: usersRolesImportInformation.value?.lastUserRolesImportAt,
      }
    })

    function afterUsersRolesImport() {
      store.dispatch('setUsersRolesImportInformation')
    }

    function downloadCSV() {
      return usersRolesService.downloadUsersRoles(distributorId.value, partner.value.name)
    }

    return {
      afterUsersRolesImport,
      capitalize,
      csvProperties: csvFileProperties,
      downloadCSV,
      importInformation,
      partner,
      distributorId,
      usersRolesImportInformation,
      usersRolesService,
    }
  },
}
